<ion-card>
    <ion-fab vertical="center" horizontal="end">
        <ion-fab-button (click)="openModalPicture()" size="small" color="light">
            <ion-icon name="camera"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <ion-card-content>
      <ion-label (click)="openModalPicture()">Pictures Taken : {{document.photosURL ? document.photosURL.length : 0}}</ion-label>
  </ion-card-content>
  
</ion-card>
